module.exports = __webpack_public_path__ + "static/img/loading-utensils.820bb12.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading-utensils.gif
// module id = kSN1
// module chunks = 1